import AgentPackageAPI from "../api/AgentPackageAPI";

const search = async (hidePackage) => {
    try {
        const result = await AgentPackageAPI.search(hidePackage);
        return result;
    } catch (err) {
        console.log(err)
    }
}

export default {
    search,
}